export default "__VITE_PUBLIC_ASSET__fe77949e__"